import React from "react"

export default function TypeText({ value }) {
  return <div>{value} </div>
}
